const HomeSupportBlock = () => {
  return (
    <div className=" mb-[120px] hidden w-full justify-center lg_flex">
      <div className="max-w-full lg_w-[1360px]">
        <p className="mb-[46px] text-center text-[48px] font-[700] leading-[48px] text-title">
          Remarkably support
        </p>
        <div className="items-cneter flex justify-between">
          <div className="flex w-[400px] flex-col items-center justify-center rounded-[24px] bg-[#f8f8f8] p-[36px]">
            <img
              className="mb-[48px] block h-[98px] w-auto"
              src="/icons/support-1.svg"
            />
            <p className="mb-[8px] text-center text-[48px] font-[700] leading-[56px] text-primary">
              10,000+
            </p>
            <p className="mb-[8px] text-center text-[24px] font-[700] leading-[32px] text-title">
              Bird Species
            </p>
            <p className="text-center text-[24px] leading-[28px] text-[#777]">
              Intelligent and powerful.{" "}
            </p>
          </div>

          <div className="flex w-[400px] flex-col items-center justify-center rounded-[24px] bg-[#f8f8f8] p-[36px]">
            <img
              className="mb-[48px] block h-[98px] w-auto"
              src="/icons/support-2.svg"
            />
            <p className="mb-[8px] text-center text-[48px] font-[700] leading-[56px] text-primary">
              Free
            </p>
            <p className="mb-[8px] text-center text-[24px] font-[700] leading-[32px] text-title">
              ID Service
            </p>
            <p className="text-center text-[24px] leading-[28px] text-[#777]">
              Name every guest.{" "}
            </p>
          </div>

          <div className="flex w-[400px] flex-col items-center justify-center rounded-[24px] bg-[#f8f8f8] p-[36px]">
            <img
              className="mb-[48px] block h-[98px] w-auto"
              src="/icons/support-3.svg"
            />
            <p className="mb-[8px] text-center text-[48px] font-[700] leading-[56px] text-primary">
              Free
            </p>
            <p className="mb-[8px] text-center text-[24px] font-[700] leading-[32px] text-title">
              Cloud Storage
            </p>
            <p className="text-center text-[24px] leading-[28px] text-[#777]">
              Endless space to play.{" "}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HomeSupportBlock
